import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserSessionDto } from '../models/api/userSessionDto';
import { UserSessionStartRequest } from '../models/api/userSessionStartRequest';
import { UserSessionReportSimpleRequest } from '../models/api/userSessionReportSimpleRequest';
import { UserSessionReportAdvancedRequest } from '../models/api/userSessionReportAdvancedRequest';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserSessionService {
  private http = inject(HttpClient);
  private readonly API_BASE_URL = `${environment.apiUrl}/user-sessions`;

  startSession(request: UserSessionStartRequest): Observable<UserSessionDto> {
    return this.http.post<UserSessionDto>(this.API_BASE_URL, request);
  }

  endSession(id: string): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(`${this.API_BASE_URL}/${id}/end`, {});
  }

  heartbeat(id: string): Observable<{ active: boolean }> {
    return this.http.put<{ active: boolean }>(`${this.API_BASE_URL}/${id}/heartbeat`, {});
  }

  checkAction(request: UserSessionStartRequest): Observable<UserSessionDto> {
    return this.http.post<UserSessionDto>(`${this.API_BASE_URL}/check-action`, request);
  }

  downloadSimpleReport(request: UserSessionReportSimpleRequest): Observable<Blob> {
    let params = new HttpParams();
    if (request.userId) params = params.set('userId', request.userId);
    if (request.date) params = params.set('date', request.date);
    if (request.period !== undefined) params = params.set('period', request.period.toString());

    return this.http.get(`${this.API_BASE_URL}/reports/simple`, {
      params,
      responseType: 'blob'
    });
  }

  downloadAdvancedReport(request: UserSessionReportAdvancedRequest): Observable<Blob> {
    let params = new HttpParams();
    if (request.userId) params = params.set('userId', request.userId);
    if (request.section) params = params.set('section', request.section);
    if (request.year) params = params.set('year', request.year.toString());
    if (request.countryId) params = params.set('countryId', request.countryId);

    return this.http.get(`${this.API_BASE_URL}/reports/advanced`, {
      params,
      responseType: 'blob'
    });
  }
}
